import React from "react";
import "./chartcontainer.scss";
import { ResponsiveContainer } from "recharts";
function ChartContainer({ title, width, height, aspect, children }) {
  return (
    <div className="chart">
      <div className="title">{title}</div>
      <ResponsiveContainer width={width} height={height} aspect={aspect}>
        {children}
      </ResponsiveContainer>
    </div>
  );
}

export default ChartContainer;
